<button
  class="tag-short-button"
  mat-flat-button
  [style.background-color]="
    tags.length && tags[0] ? tags[0].color : 'transparent'
  "
  [matTooltip]="tooltip"
  [attr.data-testid]="'tag-short-button'"
>
  <mat-icon [attr.data-testid]="'tag-icon'">bookmark</mat-icon>

  <ng-container *ngIf="tags.length === 1 && tags[0] as tag">
    <span [attr.data-testid]="'single-tag-name'">{{ tag.name }}</span>
  </ng-container>

  <ng-container *ngIf="tags.length > 1" i18n>
    <span [attr.data-testid]="'multiple-tags-count'"
      >{{ tags.length }} 個分類</span
    >
  </ng-container>

  <ng-container *ngIf="tags.length === 0" i18n>
    <span [attr.data-testid]="'no-tags-text'">沒有分類</span>
  </ng-container>
</button>
